import { unMasked } from "./cpf";



export const validarTelefoneCelular = (value: string) => {
    if (!value) return Promise.resolve('')
    value = unMasked(value)

    if (value.length < 10) {
        return Promise.reject('Campo deve conter no mínimo 10 dígitos');
    }
    return Promise.resolve();

}


export function maskTelefone(phoneNumber: any) {
    if (!phoneNumber) return;
    
    phoneNumber = phoneNumber.replace(/\W/g, '').replace("_", "")
    
    if (phoneNumber.length === 11) {
        return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(2, 7)}-${phoneNumber.slice(7)}`;
    } else {
        return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(2, 6)}-${phoneNumber.slice(6)}`;
    }
}    



export function onKeyDownBloquearDigitosPorLength(event:any,length:number) {
    let target = event?.target
    let value = target?.value
    if(value) {                                            
        value = value.replace(/\D/g, '').replace("-","").replace("_","")
        if(value.length === length && event.code.includes("Digit")) {
            event.preventDefault()                                                
        }                                            
    }
}